(function () {
  if (window.__teaQuizHubUserFix20260724) return;
  window.__teaQuizHubUserFix20260724 = 1;

  function getSiteHeaderHeight() {
    var header =
      document.querySelector('.section-header.shopify-section-group-header-group') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.getElementById('header') ||
      document.querySelector('.header-wrapper');
    return header ? header.offsetHeight || 0 : 0;
  }

  function scrollToResultsTitle() {
    var anchor =
      document.querySelector('.quiz-constitution-results__title') ||
      document.querySelector('.quiz-constitution-results__header') ||
      document.getElementById('quiz-results') ||
      document.querySelector('[data-quiz-constitution-results]');
    if (!anchor) return false;
    var top =
      anchor.getBoundingClientRect().top + (window.pageYOffset || 0) - (getSiteHeaderHeight() + 16);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function installShowcaseCss() {
    if (document.getElementById('tea-quiz-hub-showcase-css-20260724')) return;
    var style = document.createElement('style');
    style.id = 'tea-quiz-hub-showcase-css-20260724';
    style.textContent =
      '.quiz-constitution-results__toc-link{gap:.75rem;min-height:3.75rem;padding:.95rem 1.65rem;font-size:1.35rem;}' +
      '.quiz-constitution-results__toc-name{font-size:clamp(1.65rem,5vw,2.1rem)!important;font-weight:700!important;line-height:1.1!important;}' +
      '.quiz-constitution-results__toc-percent{font-size:clamp(1.85rem,5.5vw,2.35rem)!important;font-weight:700!important;line-height:1!important;opacity:1!important;}' +
      '@media(min-width:750px){.quiz-constitution-results__toc-link{min-height:4rem;padding:1rem 1.85rem;font-size:1.45rem;}' +
      '.quiz-constitution-results__toc-name{font-size:2.15rem!important;}' +
      '.quiz-constitution-results__toc-percent{font-size:2.45rem!important;}}';
    document.head.appendChild(style);
  }

  function installScrollGuard() {
    window.__teaQuizScrollToResultsTitle = scrollToResultsTitle;
    window.scrollToHub = scrollToResultsTitle;

    [0, 50, 150, 400, 800, 1500, 2500, 4000, 6000].forEach(function (delay) {
      window.setTimeout(function () {
        if (!document.documentElement.classList.contains('quiz-results-from-quiz')) return;
        if (document.querySelector('.quiz-constitution-results__title')) {
          scrollToResultsTitle();
        }
      }, delay);
    });

    window.addEventListener('pageshow', function () {
      if (document.documentElement.classList.contains('quiz-results-from-quiz')) {
        window.setTimeout(scrollToResultsTitle, 0);
        window.setTimeout(scrollToResultsTitle, 200);
      }
    });
  }

  function bindProductBackButtons() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      params = null;
    }
    var showBack =
      params &&
      params.get('from') === 'quiz' &&
      params.get('view') === 'quiz-results' &&
      (window.location.pathname || '').indexOf('/products/') !== -1;

    if (showBack && !document.getElementById('tea-quiz-product-back-wrap')) {
      var existingWrap = document.querySelector('.constitution-hub-product-back');
      if (!existingWrap) {
        var wrap = document.createElement('div');
        wrap.className = 'constitution-hub-product-back page-width';
        wrap.id = 'tea-quiz-product-back-wrap';
        wrap.innerHTML =
          '<div class="constitution-collection-info__back-wrap">' +
          '<button type="button" id="tea-quiz-browser-back-btn" class="constitution-collection-info__back constitution-collection-info__back--button">' +
          '← ひとつ前のページへ戻る</button></div>';
        var anchor =
          document.querySelector('.product_grid_max_width') ||
          document.querySelector('.product') ||
          document.querySelector('main') ||
          document.body;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(wrap, anchor);
        }
      }
    }

    document.querySelectorAll('#tea-quiz-browser-back-btn').forEach(function (btn) {
      if (btn.dataset.teaQuizBrowserBackBound === '1') return;
      btn.dataset.teaQuizBrowserBackBound = '1';
      if (btn.textContent.indexOf('ひとつ前') === -1) {
        btn.textContent = '← ひとつ前のページへ戻る';
      }
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.history.back();
        },
        true
      );
    });

    document.querySelectorAll('[data-quiz-hub-history-back], [data-quiz-hub-back-to-list]').forEach(function (node) {
      var wrap = node.closest('.constitution-hub-product-back');
      if (wrap && wrap.id !== 'tea-quiz-product-back-wrap') {
        wrap.remove();
      }
    });
  }

  installShowcaseCss();
  installScrollGuard();
  bindProductBackButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindProductBackButtons);
  }
  window.addEventListener('load', bindProductBackButtons);
  window.setInterval(bindProductBackButtons, 1000);
})();

/* tea-quiz-hub-user-fix-injected */
(function () {
  if (window.__teaQuizHubUserFix20260724) return;
  window.__teaQuizHubUserFix20260724 = 1;

  function getSiteHeaderHeight() {
    var header =
      document.querySelector('.section-header.shopify-section-group-header-group') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.getElementById('header') ||
      document.querySelector('.header-wrapper');
    return header ? header.offsetHeight || 0 : 0;
  }

  function scrollToResultsTitle() {
    var anchor =
      document.querySelector('.quiz-constitution-results__title') ||
      document.querySelector('.quiz-constitution-results__header') ||
      document.getElementById('quiz-results') ||
      document.querySelector('[data-quiz-constitution-results]');
    if (!anchor) return false;
    var top =
      anchor.getBoundingClientRect().top + (window.pageYOffset || 0) - (getSiteHeaderHeight() + 16);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function installShowcaseCss() {
    if (document.getElementById('tea-quiz-hub-showcase-css-20260724')) return;
    var style = document.createElement('style');
    style.id = 'tea-quiz-hub-showcase-css-20260724';
    style.textContent =
      '.quiz-constitution-results__toc-link{gap:.65rem;min-height:3.5rem;padding:.85rem 1.5rem;font-size:1.25rem;}' +
      '.quiz-constitution-results__toc-name{font-size:clamp(1.4rem,4.5vw,1.75rem)!important;font-weight:700!important;line-height:1.15!important;}' +
      '.quiz-constitution-results__toc-percent{font-size:clamp(1.55rem,5vw,2rem)!important;font-weight:700!important;line-height:1!important;opacity:1!important;}' +
      '@media(min-width:750px){.quiz-constitution-results__toc-link{min-height:3.85rem;padding:.95rem 1.75rem;font-size:1.35rem;}' +
      '.quiz-constitution-results__toc-name{font-size:1.9rem!important;}' +
      '.quiz-constitution-results__toc-percent{font-size:2.15rem!important;}}';
    document.head.appendChild(style);
  }

  function installScrollGuard() {
    window.__teaQuizScrollToResultsTitle = scrollToResultsTitle;
    window.scrollToHub = scrollToResultsTitle;

    [0, 50, 150, 400, 800, 1500, 2500, 4000, 6000].forEach(function (delay) {
      window.setTimeout(function () {
        if (!document.documentElement.classList.contains('quiz-results-from-quiz')) return;
        if (document.querySelector('.quiz-constitution-results__title')) {
          scrollToResultsTitle();
        }
      }, delay);
    });

    window.addEventListener('pageshow', function () {
      if (document.documentElement.classList.contains('quiz-results-from-quiz')) {
        window.setTimeout(scrollToResultsTitle, 0);
        window.setTimeout(scrollToResultsTitle, 200);
      }
    });
  }

  function bindProductBackButtons() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      params = null;
    }
    var showBack =
      params &&
      params.get('from') === 'quiz' &&
      params.get('view') === 'quiz-results' &&
      (window.location.pathname || '').indexOf('/products/') !== -1;

    if (showBack && !document.getElementById('tea-quiz-product-back-wrap')) {
      var existingWrap = document.querySelector('.constitution-hub-product-back');
      if (!existingWrap) {
        var wrap = document.createElement('div');
        wrap.className = 'constitution-hub-product-back page-width';
        wrap.id = 'tea-quiz-product-back-wrap';
        wrap.innerHTML =
          '<div class="constitution-collection-info__back-wrap">' +
          '<button type="button" id="tea-quiz-browser-back-btn" class="constitution-collection-info__back constitution-collection-info__back--button">' +
          '← ひとつ前のページへ戻る</button></div>';
        var anchor =
          document.querySelector('.product_grid_max_width') ||
          document.querySelector('.product') ||
          document.querySelector('main') ||
          document.body;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(wrap, anchor);
        }
      }
    }

    document.querySelectorAll('#tea-quiz-browser-back-btn').forEach(function (btn) {
      if (btn.dataset.teaQuizBrowserBackBound === '1') return;
      btn.dataset.teaQuizBrowserBackBound = '1';
      if (btn.textContent.indexOf('ひとつ前') === -1) {
        btn.textContent = '← ひとつ前のページへ戻る';
      }
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.history.back();
        },
        true
      );
    });

    document.querySelectorAll('[data-quiz-hub-history-back], [data-quiz-hub-back-to-list]').forEach(function (node) {
      var wrap = node.closest('.constitution-hub-product-back');
      if (wrap && wrap.id !== 'tea-quiz-product-back-wrap') {
        wrap.remove();
      }
    });
  }

  installShowcaseCss();
  installScrollGuard();
  bindProductBackButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindProductBackButtons);
  }
  window.addEventListener('load', bindProductBackButtons);
  window.setInterval(bindProductBackButtons, 1000);
})();

(function () {
  if (window.__teaQuizLiveFixV1StubV10) return;
  window.__teaQuizLiveFixV1StubV10 = 1;
  var ref =
    document.querySelector('script[src*="quiz-constitution-live-fix-v1.js"]') ||
    document.querySelector('script[src*="/assets/"]');
  if (!ref || !ref.src || ref.src.indexOf('/assets/') === -1) return;
  var prefix = ref.src.split('/assets/')[0] + '/assets/';
  function loadScript(name, attr) {
    var boot = document.createElement('script');
    boot.src = prefix + name + '?hubv=10&_=' + Date.now();
    boot.async = false;
    if (attr) boot.setAttribute(attr, '');
    document.head.appendChild(boot);
  }
  loadScript('tea-quiz-hub-return-critical-v1.js', 'data-tea-quiz-hub-return-critical-v1');
  loadScript('quiz-constitution-live-fix-v10.js', 'data-tea-quiz-live-fix-v10');
})();
